import { gql, TypedDocumentNode } from "@apollo/client";

import { OnboardingCertificate, OnboardingMission, OnboardingProgress } from "types/generated";

type LaunchPadTrackUserCertificate = Pick<OnboardingCertificate, "id" | "courseName">;

type LaunchPadTrackUserMission = Pick<OnboardingMission, "groupID">;

export type LaunchPadTrackOnboardingProgress = Pick<
  OnboardingProgress,
  "userLogin" | "percentage"
> & {
  certificates: LaunchPadTrackUserCertificate[] | null;
  completedMissions: LaunchPadTrackUserMission[] | null;
  inProgressMissions: LaunchPadTrackUserMission[] | null;
};

type GetLaunchPadTrackOnboardingProgressGql = {
  onboardingProgress: LaunchPadTrackOnboardingProgress[];
};

export const GET_LAUNCHPAD_TRACK_ONBOARDING_PROGRESS: TypedDocumentNode<
  GetLaunchPadTrackOnboardingProgressGql
> = gql`
  query GetLaunchPadTrackOnboardingProgress {
    onboardingProgress {
      userLogin
      percentage
      certificates {
        id
        courseName
      }
      completedMissions {
        groupID
      }
      inProgressMissions {
        groupID
      }
    }
  }
`;
